<mat-toolbar>
	Intake Details
	<span fxFlex></span>
	<div class="action-buttons">
		<button [disableRipple]="true" mat-icon-button [matMenuTriggerFor]="menu">
			<mat-icon>more_vert</mat-icon>
		</button>

		<mat-menu #menu="matMenu">
			<button [disableRipple]="true" mat-menu-item onClick="">Edit</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Share</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Copy</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Archive</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Delete</button>
		</mat-menu>
		<button [disableRipple]="true" mat-icon-button (click)="drawer.close()">
			<mat-icon>cancel</mat-icon>
		</button>
	</div>
</mat-toolbar>
<div class="drawer-content">
	<div class="detail-section">
		<agm-map [zoom]="10" [latitude]="latitude" [longitude]="longitude" [fullscreenControl]="true">
			<agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>
		</agm-map>

		<div class="content-section">
			<div *ngFor="let item of intakeVideo | keyvalue">
				<div class="__content">
					<div class="detail-card">
						<div class="__header">
							<!-- <h4>{{ item.key }}</h4> -->
						</div>
						<div class="__content">
							<portals-video-player [videoUrl]="item.value"></portals-video-player>
						</div>
					</div>
				</div>
			</div>
			<div *ngFor="let item of intakeDuration | keyvalue">
				<div class="__content">
					<div class="detail-card">
						<div class="__header">
							<h4>{{ item.key }}</h4>
						</div>
						<div class="__content">
							<p>{{ item.value }}</p>
						</div>
					</div>
				</div>
			</div>
			<div *ngFor="let item of intakeStatus | keyvalue">
				<div class="__content">
					<div class="detail-card">
						<div class="__header">
							<h4>{{ item.key }}</h4>
						</div>
						<div class="__content">
							<p>{{ item.value }}</p>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div class="detail-card">
					<portals-tag [tags]="tags"></portals-tag>
				</div>
			</div>
			<div class="__header">
				<h4>Comments</h4>
			</div>
			<mat-list class="comment-content">
				<mat-list-item *ngFor="let item of intakeComments | keyvalue">
					<div class="detail-card">
						<div class="__content">
							<p>{{ item.value.text }}</p>
						</div>
					</div>
					<mat-divider></mat-divider>
				</mat-list-item>
			</mat-list>
			<div class="comment-box">
				<form>
					<textarea rows="3" placeholder="Type your message here..."></textarea>
					<button [disableRipple]="true" mat-flat-button color="accent" class="comment-button">Send Comment</button>
				</form>
			</div>
		</div>
	</div>
</div>
